<button
  (click)="button_click.emit()"
  mat-button
  [ngClass]="button_class">
  <span [ngClass]="button_cta_class">
    {{ button_cta || '' | translate }}
  </span>
</button>
